import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=34a9ed2a&scoped=true"
import script from "./summary.vue?vue&type=script&lang=ts"
export * from "./summary.vue?vue&type=script&lang=ts"
import style0 from "./summary.vue?vue&type=style&index=0&id=34a9ed2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a9ed2a",
  null
  
)

export default component.exports